export const buildCounselorStudentParentPayload = ({
  messageBody,
  dstId,
  sendToStudent = false,
  sendToParent = false,
  attachmentUrl,
  single = false,
}) => {
  const ids = Array.isArray(dstId)
    ? dstId.filter(Boolean)
    : dstId != null
    ? [dstId]
    : [];
  const payload = {
    message_body: messageBody,
    dst_id: ids,
  };

  if (sendToStudent && sendToParent) {
    payload.event_type = "counselor_student";
    payload.parent_ack = true;
  } else if (sendToParent) {
    payload.event_type = "counselor_parent";
    payload.parent_ack = true;
  } else {
    payload.event_type = "counselor_student";
  }

  if (attachmentUrl) {
    payload.attachment_url = attachmentUrl;
  }

  if (single) {
    payload.single = true;
  }

  return payload;
};

export const hasCounselorStudentParentSelection = (sendToStudent, sendToParent) =>
  Boolean(sendToStudent || sendToParent);
